import { makeAutoObservable } from 'mobx'
import type { DeleteDoctorDocument } from 'domain/usecases/document/delete-doctor-document'
import { GenerateAwsPresignedUrlDocument } from 'domain/usecases/document/generate-aws-presigned-url-document'
import { UploadDocumentAws } from 'domain/usecases/document/upload-document-aws'
import { ProcessDocumentAws } from 'domain/usecases/document/process-document-aws'

type Services = {
  deleteDoctorDocument: DeleteDoctorDocument
  generateAwsPresignedUrlDocument: GenerateAwsPresignedUrlDocument
  uploadDocumentAws: UploadDocumentAws
  processDocumentAws: ProcessDocumentAws
}

export class DocumentService {
  constructor(private readonly services: Services) {
    makeAutoObservable(this)
  }

  async deleteDoctorDocument(
    params: DeleteDoctorDocument.Params
  ): Promise<DeleteDoctorDocument.Model> {
    await this.services.deleteDoctorDocument.delete(params)
  }

  async generateAwsPresignedUrlDocument(
    params: GenerateAwsPresignedUrlDocument.Params
  ): Promise<GenerateAwsPresignedUrlDocument.Model> {
    return this.services.generateAwsPresignedUrlDocument.generate(params)
  }

  async uploadDocumentAws(
    params: UploadDocumentAws.Params
  ): Promise<UploadDocumentAws.Model> {
    return this.services.uploadDocumentAws.upload(params)
  }

  async processDocumentAws(
    params: ProcessDocumentAws.Params
  ): Promise<ProcessDocumentAws.Model> {
    return this.services.processDocumentAws.process(params)
  }
}

export default DocumentService
